import axios from "axios"

const api = "tienda/produccion";

const listado = {
    listado: (id_tienda,params) =>  axios.get(`${api}/${id_tienda}/get-tienda-pedidos`,{params}),
    
}

export default listado  